<template>
    <a
        v-if="isAuth"
        :href="$getSubdomainLink('portal', '/home')"
        class="navbar__logo"
    >
        <img src="@/assets/images/logo.svg" :alt="appName" />
    </a>
    <a v-else :href="$getSubdomainLink('', '/')" class="navbar__logo">
        <img src="@/assets/images/logo.svg" :alt="appName" />
    </a>
</template>

<script>
import config from "@/config";
import { useAuthStore } from "@/stores";
export default {
    data() {
        return {
            authStore: useAuthStore(),
            appName: config.appName,
        };
    },
    computed: {
        isAuth() {
            return this.authStore.isAuth;
        },
    },
};
</script>
